/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

window.riotctrl = {
	events: {},
	// events that have already been fired
	burnt: {},
	// if listener wants to know if it's already been fired, name the event with this string in it
	RETROACTIVE: '-retro',

	on: function(name, callback, ctx) {
		(this.events[name] || (this.events[name] = [])).push({
			fn: callback,
			ctx: ctx
		});

		if (!!this.burnt[name] && name.indexOf(this.RETROACTIVE) !== -1) {
			// it already happened and this event is retro-active, so fire immediately with any data that was sent with it then
			callback.apply(ctx, this.burnt[name]);
		}

		return this;
	},

	once: function(name, callback, ctx) {
		var self = this;
		// disable esLint for the following line
		// since its calls back into itself and we dont want to change the scope
		var fn = function() { //eslint-disable-line func-style
			self.off(name, fn);
			callback.apply(ctx, arguments);
		};

		return this.on(name, fn, ctx);
	},

	trigger: function(name) {
		var data = [].slice.call(arguments, 1); // convert args to array
		var evtArr = (this.events[name] || []).slice(); // clone arr (probably not necessary, but safe)
		var i = 0;
		var evt = null;

		for (i; evt = evtArr[i]; i++) {  //eslint-disable-line no-cond-assign
			evt.fn.apply(evt.ctx, data);
		}

		if (name.indexOf(this.RETROACTIVE) !== -1) {
			// record emission for future listeners
			this.burnt[name] = data;
		}

		return this;
	},

	off: function(name, callback) {
		var evts = this.events[name];
		var liveEvents = [];

		if (evts && callback) {
			for (var i = 0, len = evts.length; i < len; i++) {
				if (evts[i].fn !== callback) liveEvents.push(evts[i]);
			}
		}

		// remove event from queue to prevent memory leak
		if (liveEvents.length) {
			this.events[name] = liveEvents;
		}
		else {
			delete this.events[name];
		}

		return this;
	}
};
